import { scenes } from "@/mocks/kanliao";

export default function Scenes() {
  return (
    <section id="scenes" className="container-px py-16 md:py-24">
      <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
        <div className="lg:sticky lg:top-28">
          <span className="section-title">适用场景</span>
          <h2 className="heading mt-4">总有一种更新，值得不错过</h2>
          <p className="prose-p mt-4 leading-8">
            无论你是追更心仪内容的爱好者、关注行业动态的从业者，还是蹲守限量新料的效率派，
            订阅提醒都能把关键的新料第一时间送到你面前。选择最贴近你的场景，开启专属推送通知。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-2xl bg-accent-100/70 p-4">
            <i
              className="ri-lightbulb-flash-line text-2xl text-accent-700"
              aria-hidden="true"
            ></i>
            <p className="text-sm text-accent-900">
              不确定订阅什么？从最常刷新、最怕错过的那个栏目开始准没错。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {scenes.map((scene, index) => {
            const featured = index === 0;
            return (
              <article
                key={scene.title}
                className={`group flex rounded-2xl border border-background-200/70 bg-background-100/60 p-6 transition-colors hover:border-secondary-300 ${
                  featured ? "flex-col sm:col-span-2 sm:flex-row" : "flex-col"
                }`}
              >
                <span
                  className={`flex shrink-0 items-center justify-center rounded-xl ${
                    featured ? "h-16 w-16" : "h-12 w-12"
                  } ${
                    scene.tint === "accent"
                      ? "bg-accent-500 text-background-50"
                      : "bg-primary-500 text-background-50"
                  }`}
                >
                  <i
                    className={`${scene.icon} ${featured ? "text-3xl" : "text-2xl"}`}
                    aria-hidden="true"
                  ></i>
                </span>
                <div className={featured ? "mt-4 sm:mt-0 sm:ml-5" : "mt-4"}>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">
                    {scene.title}
                  </h3>
                  <p
                    className={`mt-2 text-sm leading-7 text-foreground-600 ${
                      featured ? "max-w-xl" : ""
                    }`}
                  >
                    {scene.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}